import {FITH2GameConfig} from "../configs/FITH2GameConfig";


export class HighSymbolReelArea extends PIXI.Container{

    private getReelAreaWidth(): number {
        return (FITH2GameConfig.symbolWidth * FITH2GameConfig.reelsNum) + 20;
    }

    private getReelAreaHeight(): number {
        return FITH2GameConfig.symbolHeight * 6;
    }

    constructor() {
        super();
        this.name = "HighSymbolReelArea";
        this.position=FITH2GameConfig.reelAreaPos;
        const mainReelsMask: PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "reelAreaMask";
        mainReelsMask.beginFill(0xFFFF0B, 1);
        mainReelsMask.drawRect(-FITH2GameConfig.symbolWidth, 0, this.getReelAreaWidth() + FITH2GameConfig.symbolWidth, this.getReelAreaHeight());

        // todo enable reel area masking
        this.addChild(mainReelsMask);
        this.mask = mainReelsMask;
    }
}